module.exports = __webpack_public_path__ + "static/media/norte_platea.2de96bef.mp4";